module.exports = __webpack_public_path__ + "7e839798d0157be320b76d5ad8db7101.svg";